module.exports = __webpack_public_path__ + "static/ibm-plex-sans-v7-latin-regular-263d6267533501f58c33b12b382e3abb.woff2";